export const redundancyConstant = {
  'evfr-redundancy': 'Auto Redundancy',
  manualAdminRedundancy: 'Manual Redundancy',
  newPartnerRedundancy: 'New Partner Redundancy',
  qualityRecoveryRedundancy: 'Quality Recovery Redundancy',
};

export const backupConstant = {
  autoBackupRedundancy: 'Auto Backup',
  manualBackupRedundancy: 'Manual Backup',
};

export const standbyConstant = {
  manualStandbyRedundancy: 'Standby',
};

export const shadowConstant = {
  autoShadowRedundancy: 'Auto Shadow',
  manualShadowRedundancy: 'Manual Shadow',
};

export const ambassadorLedConstant = {
  autoAmbassadorLedRedundancy: 'Auto Ambassador Led',
  manualAmbassadorLedRedundancy: 'Manual Ambassador Led',
};
